import { useUserInfo } from "@next-platform/client-common-core";
import useMyRulebooks from "@next-platform/client-common-core/rulebook/attach/useMyRulebooks";
import React, { memo, useCallback } from "react";
import { useOutletContext } from "react-router-dom";

import type { OutletContextType } from "@/pages/Creations/CreationLayout";
import useRulebookDraftOwner from "@/pages/RulebookEditor/hooks/useRulebookDraftOwner";
import RulebookDraftsList from "@/pages/RulebookEditor/RulebookDraftsList";

/** My Rulebooks: this browser's drafts merged with the account's saved Rulebooks, as My Characters does with drafts and chatbots. */
const RulebookMyLoggedIn = () => {
  const [search, , sort] = useOutletContext<OutletContextType>();
  const { onlyUserId } = useUserInfo();
  // Drafts are read only once the store is scoped to this account.
  const isDraftOwnerReady = useRulebookDraftOwner(onlyUserId);
  const { rulebooks: savedRulebooks, isLoading: isSavedLoading, hasError: hasSavedError, reload } = useMyRulebooks({ isEnabled: isDraftOwnerReady });
  const reloadSaved = useCallback(() => void reload(), [reload]);
  // The hook only flips isLoading once its effect runs; until the first list (or failure) lands the saved side is still pending.
  const isSavedPending = isSavedLoading || (savedRulebooks === null && !hasSavedError);

  return (
    <div data-testid="RulebookMyLoggedIn" className="rulebookEditor mt-lg">
      {isDraftOwnerReady ? (
        <RulebookDraftsList
          search={search}
          sort={sort}
          savedRulebooks={savedRulebooks}
          isSavedLoading={isSavedPending}
          hasSavedError={hasSavedError}
          onReloadSaved={reloadSaved}
        />
      ) : null}
    </div>
  );
};

export default memo(RulebookMyLoggedIn);
